import React from 'react';
import { useAudioController } from '@store/audio/AudioController';
import { usePlayerTrackInfo } from './usePlayerTrackInfo';

export interface UseSetPageTitleProps {
  defaultTitle: string;
}
export const useSetPageTitle = ({ defaultTitle }: UseSetPageTitleProps) => {
  const { activeTrackId, playing } = useAudioController();

  const { releaseInfo } = usePlayerTrackInfo({
    trackId: activeTrackId,
    shouldFetch: true,
  });

  const [pageTitle, setPageTitle] = React.useState<string>(defaultTitle);

  // Update the document title with the current track
  // This is used for the browser tab title
  React.useEffect(() => {
    if (playing && releaseInfo) {
      setPageTitle(
        releaseInfo.artist
          ? `${releaseInfo.title} • ${releaseInfo.artist.name}`
          : releaseInfo.title,
      );
    }
  }, [releaseInfo, playing]);

  // // User stops the song, revert to the page title
  React.useEffect(() => {
    if (!playing) {
      setPageTitle(defaultTitle);
    }
  }, [playing, pageTitle, defaultTitle]);
  return pageTitle;
};
